var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarWide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 90,
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 2533.92 289.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:white;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.84,245.37v38H280.24v83.2h93.6v37.2h-93.6v118.4h-40.8V245.37Z",
    transform: "translate(-239.44 -235.84)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M601.84,245.37l106.4,276.8H665l-22-59.6H517.84l-21.6,59.6H453l105.2-276.8ZM531,426.17h98.4l-49.6-134Z",
    transform: "translate(-239.44 -235.84)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M911.84,245.37a126.46,126.46,0,0,1,38,5.4,83.55,83.55,0,0,1,29.6,16,69.1,69.1,0,0,1,19,26.6q6.6,16,6.6,37.2,0,33.21-15.6,53.2T947,411.37l71.2,110.8h-46.4l-66.4-106.4h-66v106.4h-40.8V245.37Zm-72.4,135.2h73.2q24,0,38.8-12t14.8-37.2q0-25.2-14.8-37t-38.8-11.8h-73.2Z",
    transform: "translate(-239.44 -235.84)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1331.27,397.37q-24.4,0-37.69,12.11t-13.28,34.18q0,21.68,14.16,33.69t39.94,12q36.91,0,57.23-29.1t20.31-82h37.89q0,46.68-14.65,79.49t-42.38,50.1q-27.73,17.28-67.19,17.28-40,0-62-21.29t-22-60.15q0-34.77,19.14-55.67t54.1-24.22Zm89.26,124.8-108.2-112.89a158.61,158.61,0,0,1-31.74-44.92A118.42,118.42,0,0,1,1269.36,314q0-37.11,19.92-57.62t56.25-20.51q36.13,0,56,19.63T1421.31,311h-39.84q0-17.39-9.37-26.86t-26.57-9.47q-17.19,0-26.76,10.25t-9.57,29q0,17.19,8.4,35.45a132.12,132.12,0,0,0,23.64,34.66l129.88,138.09Z",
    transform: "translate(-239.44 -235.84)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.37,245.37l49.2,202.8,58.4-202.8h39.6l57.6,202.8,50.4-202.8H2013l-69.6,276.8h-39.6l-61.2-202.8-63.2,202.8h-38.8l-68.4-276.8Z",
    transform: "translate(-239.44 -235.84)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2145,245.37v276.8h-41.2V245.37Z",
    transform: "translate(-239.44 -235.84)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2343,245.37a162.1,162.1,0,0,1,56.2,9.6,135.9,135.9,0,0,1,45.6,27.4,125.67,125.67,0,0,1,30.4,43.2q11,25.41,11,57.4t-11.2,57.8a129,129,0,0,1-30.6,43.8,137.06,137.06,0,0,1-45.4,27.8,157.36,157.36,0,0,1-56,9.8h-81.2V245.37Zm-40,239.2h40.4a113.22,113.22,0,0,0,39.6-6.8,91.89,91.89,0,0,0,54-51.6q8-18.8,8-42.8,0-23.6-7.8-42.2a89.3,89.3,0,0,0-21.6-31.4,95.2,95.2,0,0,0-32.4-19.6,115.1,115.1,0,0,0-39.8-6.8H2303Z",
    transform: "translate(-239.44 -235.84)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2770.56,245.37v38h-134v78.8h99.6V399h-99.6v85.2h136.8v38h-177.6V245.37Z",
    transform: "translate(-239.44 -235.84)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarWide);
export default __webpack_public_path__ + "static/media/far_wide.e247cf203684b7ec62f1213676552179.svg";
export { ForwardRef as ReactComponent };